import {
    ADD_DS_CSLINE,
    CHANGE_DS_CSLINE,
    DEL_DS_CSLINE,
    DEL_ALLDS_CSLINE,
    CHANGE_SELROW_CSLINE,
    CHANGE_NAME_CSLINE,
    ISDEL_CSLINE
} from './actions';

const initData = {
    dataset: [
        //ID = データセットID
        //name = データセット名称
        //coords = [[ボーリングID(ボーリング上でない場合null), 経度, 緯度]]
        //dist = 断面ライン距離
        //divNum = 断面推定の分割数のvalue
        //estFlg = 推定フラグ（0=未推定  1=推定済み）
        //{ID: 1, name: 'AB', coords: [[1_1, 141.44, 43.19], [1_2, 142.72, 42.85], [null, 143.53, 43.21]], dist: 100, divNum: 3, estFlg: 0}
    ],
    selRow: null,
    name: '',
    isDel: false
};

export function csLineReducer(state = initData, action) {
    switch (action.type) {
        case ADD_DS_CSLINE:
            return addDsReduce(state, action);
        case CHANGE_DS_CSLINE:
            return changeDsReduce(state, action);
        case DEL_DS_CSLINE:
            return delDsReduce(state, action);
        case DEL_ALLDS_CSLINE:
            return delAllDsReduce(state, action);
        case CHANGE_SELROW_CSLINE:
            return changeSelRowReduce(state, action);
        case CHANGE_NAME_CSLINE:
            return changeNameReduce(state, action);
        case ISDEL_CSLINE:
            return isDelReduce(state, action);
        default:
            return state;
}
}

export function changeNameReduce(state, action) {
    return {
        ...state,
        name: action.value
    };
}

export function addDsReduce(state, action) {
    console.log({ID: action.data.ID, name: action.data.name, coords: action.data.coords, dist: action.data.dist, divNum: action.data.divNum, estFlg: action.data.estFlg});
    return {
        ...state,
        dataset: state.dataset.concat(action.data)
    };
}

export function changeDsReduce(state, action) {
    return {
        ...state,
        dataset: state.dataset.map(el => el.ID === action.data.ID ? action.data : el)
    };
}

export function delDsReduce(state, action) {
    return {
        ...state,
        dataset: state.dataset.filter(el => el.ID - 1 !== action.rowID)
    };
}

export function delAllDsReduce(state) {
    return {
        ...state,
        dataset: []
    };
}

export function changeSelRowReduce(state, action) {
    return {
        ...state,
        selRow: action.rowID
    };
}

export function isDelReduce(state, action) {
    return {
        ...state,
        isDel: action.isDel
    };
}
